<template>
  <div id="finalticket">
    <Printer title="Final Ticket Report">
      <template v-slot:printContent>
        <p style="font-size: 8pt">
          Within 19 months of the end of the course, fill in the date the
          participant completed his or her ticket. Leave this space blank for anyone
          who did not complete their ticket. Save this report as "Final Ticket
          Report." Submit it as directed in the
          <i>Schedule of Course Reports and Transmittals.</i>
        </p>
        <div class="row">
          <div class="ml-1 col-2">
            <b>Course Number:</b>
          </div>
          <div class="data-field col-3">
            {{ reportInfo.Header.CourseName }}
          </div>
          <div class="text-right col-2">
            <b>Course Dates:</b>
          </div>
          <div
            class="data-field col-4"
          >
            {{ reportInfo.Header.Dates }}
          </div>
        </div>
        <div class="row mb-3">
          <div class="ml-1 col-2">
            <b>Host Council:</b>
          </div>
          <div class="data-field col-3">
            {{ reportInfo.Header.HostingCouncil }}
          </div>
          <div class="text-right col-2">
            <b>Location(s):</b>
          </div>
          <div
            class="data-field col-4"
          >
            {{ reportInfo.Header.Locations }}
          </div>
        </div>
        <div class="row ml-1 mr-1">
          <div class="col-2 r-header">
            Name (Last, First)
          </div>
          <div class="col-2 r-header">
            Occupation
          </div>
          <div class="col-2 r-header">
            Home Council
          </div>
          <div class="col-2 r-header">
            District
          </div>
          <div class="col-2 r-header">
            Scouting Position
          </div>
          <div class="col-2 r-header">
            Ticket Completion Date
          </div>
        </div>
        <div
          class="row ml-1 mr-1"
          v-for="r in reportInfo.Details"
          :key="r.FullName"
        >
          <div class="col-2 r-cell">
            {{ r.FullName }}
          </div>
          <div class="col-2 r-cell">
            {{ r.Occupation }}
          </div>
          <div class="col-2 r-cell">
            {{ r.CouncilName }}
          </div>
          <div class="col-2 r-cell">
            {{ r.District }}
          </div>
          <div class="col-2 r-cell">
            {{ r.PrimaryScoutingPosition }}
          </div>
          <div class="col-2 r-cell">
            {{ r.CompleteDate }}
          </div>
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import reportsApi from '@/services/api/reports.js'
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'ReportFinalTicket',
  components: {
    Printer
  },
  data: function () {
    return {
      reportInfo: {
        Header: {},
        Details: []
      },
      cellStyle: {
        padding: '0',
        'font-size': '5pt',
        border: '1px solid black',
        'line-height': '12px'
      },
      headerCellStyle: {
        padding: '0',
        'font-size': '5pt',
        'text-align': 'center',
        'overflow-wrap': 'break-word',
        border: '1px solid black',
        'line-height': '12px'
      }
    }
  },
  mounted: function () {
    reportsApi
      .getFinalTicketReport(this.$root.courseKey)
      .then(response => {
        this.reportInfo = response
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
